// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ay-b";
export var colorBlue = "_ay-8";
export var colorDot = "_ay-0";
export var colorDotLarge = "_ay-2";
export var colorDotSmall = "_ay-1";
export var colorGreen = "_ay-7";
export var colorGrey = "_ay-3";
export var colorOrange = "_ay-5";
export var colorPink = "_ay-a";
export var colorPurple = "_ay-9";
export var colorRed = "_ay-4";
export var colorYellow = "_ay-6";